import { isLocaleCode } from '@sshop/domain';

import { env } from '@/shared/config/env';

export function routeLocale() {
  const segment = typeof window === 'undefined' ? null : window.location.pathname.split('/')[1];
  return isLocaleCode(segment) ? segment : env.DEFAULT_LOCALE;
}
